import { observer } from 'mobx-react'
import React from 'react'
import { VaultDropArea } from '../VaultDropArea/VaultDropArea';
import { VaultModals } from '../VaultModals/VaultModals';
import { SectionWrapper } from './VaultActicationFlow.styles';

export const VaultActivationFlow = observer(({ onFlowStepChange, isDontHaveBalanceSheetClicked }) => {

  return (
    <>
      <SectionWrapper style={{ padding: '0' }}>
        <VaultDropArea isDontHaveBalanceSheetClicked={isDontHaveBalanceSheetClicked} />
      </SectionWrapper>
      <VaultModals onFlowStepChange={onFlowStepChange} />
    </>
  );
});